var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountsActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.971,
    height: 18.363,
    viewBox: "0 0 21.971 18.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_25",
    "data-name": "Union 25",
    d: "M20187.592,19844.189v-1.8a2.541,2.541,0,0,0-1.91-2.463,1.063,1.063,0,1,1,.533-2.059,4.675,4.675,0,0,1,3.5,4.521v1.8a1.062,1.062,0,1,1-2.123,0Zm-5.41,0v-1.8a2.55,2.55,0,0,0-2.545-2.545h-7.221a2.544,2.544,0,0,0-2.543,2.545v1.8a1.064,1.064,0,0,1-2.129,0v-1.8a4.671,4.671,0,0,1,4.672-4.672h7.221a4.676,4.676,0,0,1,4.668,4.672v1.8a1.062,1.062,0,1,1-2.123,0Zm-10.824-12.627a4.669,4.669,0,1,1,4.672,4.668A4.675,4.675,0,0,1,20171.357,19831.563Zm2.123,0a2.546,2.546,0,1,0,2.549-2.549A2.551,2.551,0,0,0,20173.48,19831.563Zm7.828,3.76a1.066,1.066,0,0,1,.766-1.291,2.547,2.547,0,0,0,0-4.936,1.063,1.063,0,1,1,.527-2.059,4.67,4.67,0,0,1,0,9.051.942.942,0,0,1-.264.035A1.069,1.069,0,0,1,20181.309,19835.322Z",
    transform: "translate(-20167.744 -19826.891)",
    fill: "#ff686e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsActiveIcon);
export default __webpack_public_path__ + "static/media/accountsActiveIcon.6c9c4f70794328a96369227300815c3a.svg";
export { ForwardRef as ReactComponent };